import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { RouterModule } from '@angular/router'

import { DetailHeaderAction, DetailHeaderModel } from '../models/detail-page.model'

@Component({
    selector: 'app-detail-header',
    standalone: true,
    imports: [CommonModule, RouterModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './detail-header.component.html',
    styleUrls: ['./detail-header.component.scss']
})
export class DetailHeaderComponent {
    @Input({ required: true }) model!: DetailHeaderModel
    @Input() testId?: string
    @Output() action = new EventEmitter<DetailHeaderAction>()

    onAction(a: DetailHeaderAction): void {
        if (a.disabled) return
        this.action.emit(a)
    }

    statusBadgeClass(tone: string | undefined): string {
        switch (tone) {
            case 'primary':   return 'badge bg-primary'
            case 'success':   return 'badge bg-success'
            case 'secondary': return 'badge bg-secondary'
            case 'warning':   return 'badge bg-warning text-dark'
            case 'danger':    return 'badge bg-danger'
            case 'info':      return 'badge bg-info text-dark'
            default:          return 'badge bg-light text-dark'
        }
    }

    actionBtnClass(tone: string | undefined): string {
        switch (tone) {
            case 'primary': return 'btn btn-sm btn-primary'
            case 'danger':  return 'btn btn-sm btn-outline-danger'
            default:        return 'btn btn-sm btn-outline-secondary'
        }
    }
}
